<template>
  <div>
    <div class="lockout-timer-wrap">
      <div v-if="remainingSeconds">
        <span class="lockout-message">
          <i class="fa fa-lock me-1 lock-icon"></i>
          Locked out. Please wait <span class="lockout-timer">{{ formattedTime }}</span>.
        </span>
      </div>
    </div>
    <div v-if="remainingSeconds">
      <div class="progress" style="margin-top: 20px;">
        <div
          class="progress-bar bg-warning"
          role="progressbar"
          :style="{ width: remainingPercentage + '%' }"
          :aria-valuenow="remainingSeconds"
          aria-valuemin="0"
          :aria-valuemax="lockoutSeconds"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LockoutTimer",
  props: {
    lockoutSeconds: {
      type: Number,
      required: true,
      default: 0
    }
  },
  data() {
    return {
      remainingSeconds: 0,
      remainingPercentage: 100
    };
  },
  computed: {
    formattedTime() {
      const minutes = Math.floor(this.remainingSeconds / 60);
      const seconds = this.remainingSeconds % 60;
      return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    }
  },
  mounted() {
    this.startTimer();
  },
  methods: {
    startTimer() {
      this.remainingSeconds = this.lockoutSeconds;
      this.remainingPercentage = 100;

      const interval = setInterval(() => {
        if (this.remainingSeconds > 0) {
          this.remainingSeconds -= 1;
          this.remainingPercentage = (this.remainingSeconds / this.lockoutSeconds) * 100;
        } else {
          clearInterval(interval);
          this.$emit('lockout-expired'); // Emit event when lockout expires
        }
      }, 1000);
    }
  }
};
</script>

<style scoped>
.lockout-timer-wrap {
  display: flex;
  justify-content: left;
  align-items: left;
  margin-top: 1rem;
}

.lockout-message {
  color: #e45462; /* Red color for lockout message */
  font-size: 1rem;
}

.lockout-timer {
  font-weight: bold;
}

.lock-icon {
  color: #dc3545;
}

.progress-bar.bg-warning {
  background-color: #e45462 !important; /* Red progress bar for lockout */
}
</style>